import produce from "immer";

const workflowReducer = (state, action) => {
  switch (action.type) {
    case "SET_PATIENT_LIST": {
      return produce(state, (draft) => {
        draft.workflow.patientList = action.payload.patientList;
      });
    }

    case "SET_SELECTED_PATIENT_ID": {
      return produce(state, (draft) => {
        draft.workflow.selectedPatientId = action.payload.selectedPatientId;
      });
    }

    case "SET_PATIENTS": {
      return produce(state, (draft) => {
        draft.workflow.patients = action.payload.patients;
      });
    }

    default:
      throw new Error();
  }
};

export default workflowReducer;
